export const GLOBAL_CONFIG = {
    profile: {
        archive: true
    }
};